import FacilitatorSupportChats from '@/src/components/game/FacilitatorSupportChats/FacilitatorSupportChats';
import React from 'react';

export const JamEventSupportChatsPage: React.FC = () => {
  return <FacilitatorSupportChats />;
};
